import React, {useState} from 'react';
import {BaseInputProps} from '../..';

import {Container, Label, StyledMultiSelect} from './styles';
import {useController, useFormContext} from 'react-hook-form';
import {SelectDataProps} from 'shared/types/select-data';
import {NestedKeys} from 'shared/types/key-manipulation';

export interface MultiSelectProps<T = any> extends BaseInputProps {
  onClick?: () => void;
  value?: string;
  placeholder?: string;
  gridColumn?: number;
  data: SelectDataProps[];
  name: NestedKeys<T>;
  creatable?: boolean;
}

const MultiSelect: React.FC<MultiSelectProps> = ({
  name,
  label,
  onClick,
  placeholder,
  gridColumn,
  data,
  border,
  creatable = false,
  disabled,
}) => {
  const [query, setQuery] = useState('');
  const [createdData, setCreatedData] = useState<SelectDataProps[]>([]);
  const [focused, setFocused] = useState(false);
  const {control} = useFormContext();
  const {field} = useController({control, name});

  const onCreate = () => {
    if (!creatable) return;

    const item = {value: query, label: query};
    setCreatedData((current) => [...current, item]);
    field.onChange([...(field.value ?? []), query]);
    setQuery('');
  };

  return (
    <Container {...{onClick, gridColumn, focused, border}}>
      <Label>{label}</Label>
      <StyledMultiSelect
        searchable
        {...{placeholder, disabled}}
        multiple
        onSearchChange={setQuery}
        searchValue={query}
        data={[...data, ...createdData]}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        value={field.value}
        onChange={field.onChange}
        onKeyDown={(event) => event.key === 'Enter' && query && onCreate()}
        //@ts-ignore
        autocomplete="nope"
        nothingFoundMessage={
          query && (
            <div
              style={{
                cursor: 'pointer',
                color: 'black',
                alignSelf: 'flex-start',
              }}
              onClick={onCreate}>
              {creatable ? `Adicionar ${query}` : 'Nenhum registro encontrado'}
            </div>
          )
        }
      />
    </Container>
  );
};

export default MultiSelect;
